import { render } from "./App.vue?vue&type=template&id=a91b43f0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a91b43f0&lang=css"

import exportComponent from "C:\\Users\\y2ktheory\\Documents\\Web Projects\\portfolio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__